module.exports = __webpack_public_path__ + "img/Score.4709cc45.jpg";